<template>
  <component
    :is="tag"
    class="icon"
    :class="modifiers"
    v-bind="attributes"
    v-on="$listeners"
  >
    <slot>
      <component
        v-if="svg"
        :is="svg"
        class="icon__svg"
      />
    </slot>
  </component>
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    tag: {
      type: String,
      default: 'span',
    },
    name: {
      type: String,
      default: '',
    },
    symbol: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    view: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
  },
  computed: {
    svg() {
      if (!this.name) return null;
      return require(`@/assets/icons/${this.name}.svg`); // eslint-disable-line
    },
    modifiers() {
      return {
        icon_type_svg: Boolean(this.name),
        icon_type_symbol: Boolean(this.symbol),
        [`icon_view_${this.view}`]: Boolean(this.view),
        [`icon_size_${this.size}`]: Boolean(this.size),
        [`icon_theme_${this.theme}`]: Boolean(this.theme),
      };
    },
    attributes() {
      const attributes = {};
      if (this.symbol) {
        attributes['data-symbol'] = this.symbol;
      }
      return { ...attributes, ...this.$attrs };
    },
  },
};
</script>

<style lang="stylus">
.icon
  display block
  fill currentColor
  color inherit

  &__svg
    display block
    width 100%
    height 100%
    fill currentColor

  [stroke-width]:not([stroke])
    stroke currentColor

  [data-fill-bg]
    fill $c_bg

  &[data-symbol]
    &:before
      content attr(data-symbol)
      font-weight 700

  &_size_xs
    width 2.8em
    height @width

  &_size_s
    width 3.85em
    height @width

  &_size_m
    width 4.8em
    height @width

  &_size_l
    width 6em
    height @width

  &_size_xl
    width 7em
    height @width

  &_size_xxl
    width 10em
    height @width

  &_view_circle
    background-color currentColor
    padding 0.5em
    border-radius 100%
    & ^[0]__svg
      color $c_text

  &_theme_primary
  &_theme_error
    color $c_primary

  &_theme_thanks
    color $c_success
</style>
